import { useEffect, useState } from "react";

export interface IDropdownItem {
    name: string;
    id: string | number;
}

export interface IDropdownMenuProps {
    selectedId?: string | number | undefined;
    items: Array<IDropdownItem>;
    onItemSelected: (item: IDropdownItem) => void;
}

export default function DropdownMenu(props: IDropdownMenuProps) {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [selectedItem, setSelectedItem] = useState<IDropdownItem | undefined>();

    useEffect(() => {
        const item = props.items.find(x => x.id === props.selectedId);
        setSelectedItem(item);
    }, [props.selectedId, props.items]);

    return (
        <>
            <div className="dropdown-menu-container">
                <div className="dropdown-menu-header" onClick={() => setIsOpen(!isOpen)}>{selectedItem?.name}</div>
                {isOpen && <div className="dropdown-menu-body" >
                    <div className="dropdown-menu-container">
                        {props.items.map((item: IDropdownItem, key: number) => (
                            <a  key={key} 
                                style={{cursor: 'pointer'}}
                                onClick={() => {
                                    setIsOpen(false);
                                    setSelectedItem(item);
                                    props.onItemSelected(item);
                                }}
                            >{item.name}</a>
                        ))}
                    </div>
                </div>}
            </div>
        </>
    );
}